import { CommentsList, CommentsShow } from 'pages/communication/comments';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'comments',
  label: 'Comentários em aulas',
  list: CommentsList,
  show: CommentsShow,
  actions: ['list', 'show'],
  parentName: 'communication'
};

export default generateResources(resource);
